/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Input, Table, Modal, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import { getAge } from '../../../constants/helper'
import ConstituentAvatar from '../../../components/Custom/ConstituentAvatar'
import ConstituentDetails from '../../Certificates/modalDetails'
import SubscribeProgress from './subscribeProgress'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isViewDetailsShown: false,
			selectedConstituent: null,
			isExporting: false,
			exportProgress: null,
			gender: []
		}
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			gender: filters.gender,
		})
	}

	render() {
		const { AuthStore, visible, onCancel, filterValue } = this.props
		const { barangay_uid, user_uid } = AuthStore
		const { 
			page, pageSize, sortOrder, sortName, searchText, gender,
			isViewDetailsShown, selectedConstituent, isExporting, exportProgress
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName, gender
		}
		
		return (
			<Modal
				title={`${filterValue}`}
				footer={null}
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				width='90%'
			>
				<Row>
					<Row>
						<Input style={{ width: 300, float: 'right', marginBottom: 20 }} placeholder='Search Here..' onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}} />
						<button 
							type="button" 
							className="btn btn-outline-success btn-rounded waves-effect waves-light"
							onClick={() => {
								const { exportConstituent } = this.props
								const params = {
									filterValue,
									searchText,
									filters
								}
								exportConstituent(params)
							}}
						>
							<i className='mdi mdi-file-excel'/> Export in Excel
						</button>
					</Row>
					<Row>
						<Query 
							query={CONSTITUENTS} 
							variables={{ 
								searchFilter: filters, 
								barangay_uid, 
								filterValue
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let constituents = _.has(data,'constituentListByStatus') ? data.constituentListByStatus.data : []
								constituents = constituents.map((constituent, key) => Object.assign({}, constituent, { key }))
								let _pagination = _.has(data, 'constituentListByStatus') ? data.constituentListByStatus.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								let columns = [
									{
										title: '#',
										key: 'avatar',
										width: 110,
										align: 'center',
										render: (record) => {
											return <ConstituentAvatar size={60} constituent_uid={record.uid} />
										}
									}, {
										title: 'Household no',
										dataIndex: 'household_no',
										key: 'household_no',
										width: 130
									}, {
										title: 'Last Name',
										dataIndex: 'last_name',
										key: 'last_name',
										width: 170
									}, {
										title: 'First Name',
										dataIndex: 'first_name',
										key: 'first_name',
										width: 170
									}, {
										title: 'Middle Name',
										dataIndex: 'middle_name',
										key: 'middle_name',
										width: 170
									}, {
										title: 'Gender',
										dataIndex: 'gender',
										key: 'gender',
										filters: [{
											value: 'Male', text: 'Male'
										}, {
											value: 'Female', text: 'Female'
										}, {
											value: 'Gay', text: 'Gay'
										}, {
											value: 'Bisexual', text: 'Bisexual'
										}, {
											value: 'Transgender', text: 'Transgender'
										}, {
											value: 'Lesbian', text: 'Lesbian'
										}],
										width: 150
									}, {
										title: 'Household Type',
										dataIndex: 'relation_in_head',
										key: 'relation_in_head',
										width: 150
									}, {
										title: 'Action',
										key: 'action',
										width: 100,
										render: (record) => {
											return (
												<React.Fragment>
													<a href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 10 }} onClick={() => this.setState({ isViewDetailsShown: true, selectedConstituent: record })}>View Details</a>
												</React.Fragment>
											)
										}
									}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'constituents-status' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={constituents} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
												rowClassName={(record, index) => (record.is_alive == 0) ? 'table-row-deceased' :  ''}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Row>
				{
					isViewDetailsShown &&
                    <ConstituentDetails 
                    	constituent_uid={selectedConstituent.uid}
                    	visible={isViewDetailsShown}
                    	onCancel={() => this.setState({ isViewDetailsShown: false, selectedConstituent: null })}
                    />
				}
			</Modal>
		)
	}
}

const CONSTITUENTS = gql`
    query constituentListByStatus($barangay_uid: String, $filterValue: String, $searchFilter: SearchParams) {
		constituentListByStatus(barangay_uid: $barangay_uid, filterValue: $filterValue, searchFilter: $searchFilter)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const EXPORT_CONSTITUENT_BY_STATUS = gql`
    mutation exportConstituentsByStatus($input: JSON) {
		exportConstituentsByStatus(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_CONSTITUENT_BY_STATUS, {
		props({ mutate }) {
			return {
				exportConstituent(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
